import { useEffect, useRef } from 'react';
import { TypedEventTarget } from 'typescript-event-target';

interface EventMap<T> {
  change: CustomEvent<T>;
}

export function useStateChangeEvents<T>(value: T) {
  const eventTarget = useRef(new TypedEventTarget<EventMap<T>>());

  useEffect(() => {
    eventTarget.current.dispatchTypedEvent(
      'change',
      new CustomEvent('change', { detail: value })
    );
  }, [value]);

  return eventTarget.current;
}
